export default {
  /**
   * 数值是否相等
   *
   * @param {Array<number, string, boolean>} array1 数组1
   * @param {Array<number, string, boolean>} array2 数组2
   * @returns {boolean} 是否相等
   */
  isEquals(array1, array2) {
    // if the other array is a falsy value, return
    if (array1 === array2) {
      return true
    }

    if (!array1 || !array2) {
      return false
    }

    // compare lengths - can save a lot of time
    if (array1.length !== array2.length) {
      return false
    }

    return array1.every(function(item) {
      return array2.includes(item)
    })
  },
  remove(array, item, keyProp) {
    let index = array.findIndex(elem => elem[keyProp] === item[keyProp])
    if (index >= 0) {
      array.splice(index, 1)
    }
    return array
  },
  /**
   * 去重
   *
   * @param {Array} array 原数组
   * @returns {Array} 去重后的数组
   */
  unique(array) {
    return Array.from(new Set(array))
  }
}
